export default function createPolicyTipsViewState() {
    return {
        inProgressPolicyMatch: createPolicyMatchWrapper(),
        succeededPolicyMatch: createPolicyMatchWrapper(),
        pendingPolicyMatch: createPolicyMatchWrapper(),
        isRequestInProgress: false,
        pendingRequests: false,
        handlerDisabled: false,
    };
}
function createPolicyMatchWrapper() {
    return {
        itemId: null,
        scanResultData: null,
        scanResultMetaData: null,
        subjectChecksum: 0,
        contentChecksum: 0,
        eventTrigger: null,
        policyMatchDetails: [],
        attachmentIds: [],
    };
}
//# sourceMappingURL=createPolicyTipsViewState.js.map